// Keeps the address bar in sync with the view (debounced, replaceState) and
// wires the "copy link" button.
import type { App } from '../app.ts';
import { $ } from './dom.ts';
import { cameraToView, encodeUrlState } from '../state/url-state.ts';

export function mountUrlSync(app: App): void {
  let timer = 0;
  const current = (withView: boolean) => {
    const view = withView && app.geom ? cameraToView(app.cam, app.viewW, app.viewH, app.is3d()) : null;
    return '?' + encodeUrlState(app.state, view);
  };
  const write = () => {
    timer = 0;
    if (app.loop.interacting) { schedule(); return; }
    const q = current(true);
    if (location.search !== q) history.replaceState(null, '', q + location.hash);
  };
  const schedule = () => {
    if (timer) clearTimeout(timer);
    timer = window.setTimeout(write, 250);
  };
  app.store.subscribe(schedule);
  app.listeners.add(schedule);   // camera moves surface via frame callbacks

  const btn = document.getElementById('btnShare');
  btn?.addEventListener('click', async () => {
    const url = location.origin + location.pathname + current(true);
    history.replaceState(null, '', current(true));
    try {
      await navigator.clipboard.writeText(url);
      app.toast('Link copied');
    } catch {
      app.toast('Clipboard blocked - the address bar now holds the link', 4000);
    }
  });
}
